<!-- TODO: Remove this and functions, we do not empty trash any more -->

<div class="expense-modal-edit">
  <header class="base-modal__header">
    <div class="base-modal__header-content">
      <h1 class="base-modal__title">Empty Trash</h1>
      <p class="base-modal__subtitle">
        You are about to permanently delete all expenses in Trash. This cannot
        be undone. Do you wish to continue?
      </p>
    </div>
    <div class="base-modal__actions">
      <ng-content select="[modal-actions]"></ng-content>
    </div>
  </header>

  <div class="expense-modal-edit__body">
    <section class="expense-modal-edit__content">
      <!-- Cancel or Empty Trash -->
      <ems-base-button-group>
        <ems-base-button
          (click)="onCancel()"
          label="Cancel"
          buttonType="tertiary"
          variant="inverted"
        >
        </ems-base-button>
        <ems-base-button
          (click)="onEmptyTrash()"
          label="Empty Trash"
          buttonType="primary"
          variant="destructive"
        >
        </ems-base-button>
      </ems-base-button-group>
    </section>
  </div>
</div>
